import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";

const Imprint: React.FC = () => {
  return (
    <Box
      component="main"
      sx={{
        py: 12,
        minHeight: "calc(100vh - 64px)",
        backgroundColor: "background.default",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 2,
            backgroundColor: "background.paper",
          }}
        >
          <Typography variant="h1" sx={{ fontSize: "2.5rem", mb: 4 }}>
            Impressum
          </Typography>

          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2, mt: 4 }}>
            Angaben gemäß § 5 TMG
          </Typography>
          <Typography paragraph>
            pyzon - Patrick Hutter
            <br />
            Soderstraße 51
            <br />
            64287 Darmstadt
          </Typography>

          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2, mt: 4 }}>
            Vertreten durch
          </Typography>
          <Typography paragraph>Patrick Hutter</Typography>

          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2, mt: 4 }}>
            Kontakt
          </Typography>
          <Typography paragraph>
            Telefon: +49 (0) 152 05 34 1897
            <br />
            E-Mail: info@pyzon.de
          </Typography>

          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2, mt: 4 }}>
            Umsatzsteuer-ID
          </Typography>
          <Typography paragraph>
            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
            <br />
            DE 32 246 2917
          </Typography>

          <Typography variant="h2" sx={{ fontSize: "1.5rem", mb: 2, mt: 4 }}>
            Streitschlichtung
          </Typography>
          <Typography paragraph>
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            Stand: April 2025
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Imprint;
